import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import animated_map from "../../Assets/mapNew.png";
import "../../styles/Home.css";

function Map() {
  const { t } = useTranslation('about');

  const styles = {
    highlightedText: {
      fontWeight: "bold",
      color: "#1662A7",
      textTransform: "uppercase",
    },
    sectionText: {
      alignSelf: "center",
      fontFamily: "Roboto, sans-serif",
      textAlign: "center",
    },
    regionText: {
      alignSelf: "center",
      fontFamily: "Roboto, sans-serif",
      color: "#25B2E8",
      textAlign: "center",
    },
    mapImage: {
      alignSelf: "center",
      width: { xs: "100%", md: "90%" },
    },
  };

  return (
    <Box pt={5} pb={3}>
      <Box px={{ xs: 3, md: 12 }}>
        <Stack direction="column" spacing={3} alignItems="center">
          <Typography
            variant="paragraph"
            sx={{ ...styles.sectionText, lineHeight: { xs: "28px", md: "45px" } }}
            fontWeight="medium"
            fontSize={{ xs: "16px", md: "28px" }}
            color="#6E6B7B"
          >
            {t('map.hostingPrefix')}
            <span style={styles.highlightedText}>{t('map.onPremise')}</span>
            {t('map.orOn')}
            <span style={styles.highlightedText}>{t('map.cloudServers')}</span>
            {t('map.locatedIn')}
          </Typography>

          <Typography
            variant="paragraph"
            sx={{ ...styles.regionText, lineHeight: { xs: "24px", md: "38px" } }}
            fontWeight="bold"
            fontSize={{ xs: "16px", md: "32px" }}
          >
            {t('map.regions')}
          </Typography>
        </Stack>

        <Box component="img" src={animated_map} sx={styles.mapImage} alt="Global Locations" />
      </Box>
    </Box>
  );
}

export default Map;
